import React from 'react';
import { ButtonLink } from '../../../../components';
import { t } from '../../../../i18n';
import UrlTo from '../../../../url-to';
import { giftCardIcon } from '../../../assets';
import './styles.scss';

const GiftCardEmployeesImageBanner = () => {
  return (
    <section className="courses-gift-card-overview__employees-image-banner">
      <h2 className="courses-gift-card-overview__employees-image-banner-header">
        {t('DIGITAL_COURSES.GIFT_CARD_OVERVIEW.GIFT_TO_HORSE_LOVER')}
      </h2>
      <ButtonLink
        href={UrlTo.coursesGiftCardCheckout()}
        type="green"
        linkClassName="courses-gift-card-overview__employees-image-banner-link"
        className="courses-gift-card-overview__employees-image-banner-button"
        text={
          <span>
            <img src={giftCardIcon} alt={t('DIGITAL_COURSES.GIFT_CARD_OVERVIEW.GIFT_CARD')} />
            {t('DIGITAL_COURSES.SPECIFIC_COURSE_SCREEN.BUY_GIFT_CARD')}
          </span>
        }
      />
    </section>
  );
};

export default GiftCardEmployeesImageBanner;
